import { render, staticRenderFns } from "./SlideView.vue?vue&type=template&id=798e05b2&scoped=true"
import script from "./SlideView.vue?vue&type=script&lang=js"
export * from "./SlideView.vue?vue&type=script&lang=js"
import style0 from "./SlideView.vue?vue&type=style&index=0&id=798e05b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798e05b2",
  null
  
)

export default component.exports